export const driverPermissionsLabels = {
  allowUploadFromStudio: "الرفع من الاستوديو",
  allowQrCodeVerification: "التوثيق عبر رمز QR",
} as const;

export const driverPermissionsDescriptions = {
  allowUploadFromStudio: "قم بتفعيل هذا الخيار للسماح للمندوب برفع الصور من تطبيق الاستوديو",
  allowQrCodeVerification: "قم بتفعيل هذا الخيار للسماح للمندوب بتوثيق الطلبات باستخدام رمز QR ",
} as const;

export type DriverPermissionKey = keyof typeof driverPermissionsLabels;

export type DriverPermissions = Record<DriverPermissionKey, boolean>;

export const driverPermissionsDefaults: DriverPermissions = Object.keys(
  driverPermissionsLabels,
).reduce((acc, key) => {
  acc[key as DriverPermissionKey] = false;
  return acc;
}, {} as DriverPermissions);
